import { render } from "./CCvirtualCommerce.vue?vue&type=template&id=47ccea89&scoped=true"
import script from "./CCvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./CCvirtualCommerce.vue?vue&type=script&lang=js"

import "./CCvirtualCommerce.vue?vue&type=style&index=0&id=47ccea89&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47ccea89"

export default script